import { ILeaferCanvas } from '@leafer/interface'
import { IUI, ICachedShape } from '@leafer-ui/interface'

export function backgroundBlur(_ui: IUI, _current: ILeaferCanvas, _shape: ICachedShape): void {

}